module.exports = __webpack_public_path__ + "/images/cover-peluche-ropa-bb-comoda.94c0d03.jpg";